<template>
  <div v-if="isTypeIdsExist" class="cffc-Cell">
    <AppIcon v-for="icon in iconsList" :key="icon" :icon-name="icon" height="24" width="24" />
  </div>
</template>

<script setup>
import { isEmpty } from 'lodash'
import { computed } from 'vue'

import { CUSTOM_FIELDS_OKR_TYPE_IDS, useFilterByPlatform } from '@/utils/custom-fields/helpers'

import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'CustomFieldForCell'
})

const props = defineProps({
  typeIds: {
    type: Array,
    required: true
  }
})

const { isTypeIdAvailable } = useFilterByPlatform()

const typeIdsByAppPlatform = computed(() => {
  return props.typeIds.filter(isTypeIdAvailable)
})

const isTypeIdsExist = computed(() => !isEmpty(typeIdsByAppPlatform.value))

const iconsList = computed(() => {
  if (!isTypeIdsExist.value) return []

  const ALL = Object.values(CUSTOM_FIELDS_OKR_TYPE_IDS).map(({ id }) => id)

  return [...typeIdsByAppPlatform.value]
    .toSorted()
    .filter(id => {
      return ALL.includes(id)
    })
    .map(id => {
      return Object.values(CUSTOM_FIELDS_OKR_TYPE_IDS).find(item => item.id === id).icon
    })
})
</script>

<style lang="scss" scoped>
.cffc-Cell {
  display: flex;
  gap: 4px;
}
</style>
